'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _handleErrors = require('./handle-errors');

var _handleResponseHeader = require('./handle-response-header');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

require('isomorphic-fetch');
require('es6-promise').polyfill();

var getUrlParamsString = function getUrlParamsString(params) {
  return Object.keys(params).map(function (k) {
    if (Array.isArray(params[k])) {
      return params[k].map(function (val) {
        return encodeURIComponent(k) + '[]=' + encodeURIComponent(val);
      }).join('&');
    }

    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
};

var RestClient = function () {
  function RestClient() {
    _classCallCheck(this, RestClient);
  }

  _createClass(RestClient, null, [{
    key: 'getDefaultHeaders',
    value: function getDefaultHeaders() {
      var isRequireContentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var contentType = arguments[1];

      var headers = {
        Accept: 'application/json',
        'x-api-key': RestClient.apiKey,
        'Spacemarket-Version': RestClient.spmApiVersion
      };

      if (isRequireContentType) {
        headers['Content-Type'] = contentType || 'application/json';
      }

      if (RestClient.accessToken) {
        headers.Authorization = 'Bearer ' + RestClient.accessToken;
      }

      return headers;
    }
  }, {
    key: 'fetchWithTimeout',
    value: function fetchWithTimeout(promise) {
      var msec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20000;

      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          reject({
            errors: [{
              message: ''
            }]
          });
        }, msec);
        promise.then(resolve, reject);
      });
    }
  }, {
    key: 'getPlainCsv',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path, params) {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = params ? '?' + getUrlParamsString(params) : '';
                return _context.abrupt('return', RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path + query, {
                  method: 'GET',
                  headers: RestClient.getDefaultHeaders(true, 'text/csv; charset=utf8')
                })).then(function (response) {
                  return response.text();
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPlainCsv(_x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return getPlainCsv;
    }()
  }, {
    key: 'get',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(path, params) {
        var query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = params ? '?' + getUrlParamsString(params) : '';
                return _context2.abrupt('return', RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path + query, {
                  method: 'GET',
                  headers: RestClient.getDefaultHeaders()
                })).then(function (response) {
                  return (0, _handleErrors.handleFetchResponse)(response);
                }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x5, _x6) {
        return _ref2.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'getWithHeader',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(path, params) {
        var query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                query = params ? '?' + getUrlParamsString(params) : '';
                return _context3.abrupt('return', RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path + query, {
                  method: 'GET',
                  headers: RestClient.getDefaultHeaders()
                })).then(function (response) {
                  return (0, _handleResponseHeader.handleResponseHeader)(response);
                }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getWithHeader(_x7, _x8) {
        return _ref3.apply(this, arguments);
      }

      return getWithHeader;
    }()
  }, {
    key: 'postJson',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(path, data) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path, {
                  method: 'POST',
                  headers: RestClient.getDefaultHeaders(),
                  body: JSON.stringify(data)
                })).then(function (response) {
                  return (0, _handleErrors.handleFetchResponse)(response);
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function postJson(_x9, _x10) {
        return _ref4.apply(this, arguments);
      }

      return postJson;
    }()
  }, {
    key: 'postFormData',
    value: function postFormData(path, data) {
      return RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path, {
        method: 'POST',
        headers: RestClient.getDefaultHeaders(false),
        body: data
      })).then(function (response) {
        return (0, _handleErrors.handleFetchResponse)(response);
      });
    }
  }, {
    key: 'patchJson',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(path, data, queryParams) {
        var query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                query = queryParams ? '?' + getUrlParamsString(queryParams) : '';
                return _context5.abrupt('return', RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path + query, {
                  method: 'PATCH',
                  headers: RestClient.getDefaultHeaders(),
                  body: JSON.stringify(data)
                })).then(function (response) {
                  return (0, _handleErrors.handleFetchResponse)(response);
                }));

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function patchJson(_x11, _x12, _x13) {
        return _ref5.apply(this, arguments);
      }

      return patchJson;
    }()
  }, {
    key: 'patchFormData',
    value: function patchFormData(path, data) {
      return RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path, {
        method: 'PATCH',
        headers: RestClient.getDefaultHeaders(false),
        body: data
      })).then(function (response) {
        return (0, _handleErrors.handleFetchResponse)(response);
      });
    }
  }, {
    key: 'delete',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(path, data) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', RestClient.fetchWithTimeout(fetch(RestClient.apiHost + '/' + path, {
                  method: 'DELETE',
                  headers: RestClient.getDefaultHeaders(),
                  body: JSON.stringify(data)
                })).then(function (response) {
                  return (0, _handleErrors.handleFetchResponse)(response);
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _delete(_x14, _x15) {
        return _ref6.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return RestClient;
}();

exports.default = RestClient;


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/rest/client.js
// module id = 130
// module chunks = 0